<template>
  <div class="flex flex-col bg-[#f8fafc] gap-6">
    <!-- Recipe Selection -->
    <div class="bg-white rounded-xl shadow-sm border border-slate-200 border-t-4 border-t-[#0d4169]">
      <div class="px-6 pt-5 pb-1 shrink-0">
        <h2 class="text-base font-bold text-[#0d4169] text-left">Recipe Selection</h2>
      </div>
      <form class="px-6 pb-5 pt-2 shrink-0" @submit.prevent>
        <div class="grid grid-cols-1 gap-x-4 gap-y-2">
          <div>
            <div class="flex flex-col md:flex-row md:items-end gap-2 md:gap-4">
              <div class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 md:flex-1">
              <label class="text-[0.78rem] font-semibold text-[#1e293b] text-left w-[150px] shrink-0">
               Choose Department:
              </label>
              <select
                v-model="selectedDepartmentId"
                class="w-full max-w-[520px] px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm bg-white cursor-pointer"
                @change="handleDepartmentSelected"
              >
                <option value="">Choose Department</option>
                <option
                  v-for="dep in departments"
                  :key="dep.id"
                  :value="String(dep.id)"
                >
                  {{ dep.name }}
                </option>
              </select>
              </div>
              <div class="w-full md:max-w-[320px]">
                <input
                  v-model="menuSearchQuery"
                  type="text"
                  class="w-full px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm bg-white"
                  placeholder="Search By Name..."
                >
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="px-6 pb-6 overflow-x-auto custom-scrollbar" v-if="isTable">
        <div v-if="menuCostsLoading" class="flex items-center justify-center py-8 gap-2 text-slate-500 text-sm">
          <div
  v-if="menuCostsLoading"
  class="h-5 w-5 border-2 border-[#0d4169] border-t-transparent rounded-full animate-spin"
></div>
          Loading recipe costs...
        </div>
        <table v-else class="mt-5 w-full">
              <thead>
                <tr>
                <th>No.</th>
                <th>Menu Name</th>
                <th>Department</th>
                <th>Sub Dept</th>
                <th>Cost</th>
                <th>Cost Percentage</th>
                <th>Original Price</th>
                <th>Addition</th>
                <th>VAT</th>
                <th>Total Price</th>
                <!-- <th>Profit In Birr</th> -->
                <th>Contingency</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(menu, index) in filteredMenuData" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>
                    <u>
                      <a @click="openRecipeModal(menu)" class="text-blue-500 cursor-pointer">
                        {{ menu.name }}
                      </a>
                    </u>
                  </td>
                  <td>{{ menu.department?.name || '-' }}</td>
                  <td>{{ menu.subDepartment?.name || '-' }}</td>
                  <td class="font-semibold">{{ menu._cost == null ? '' : money(menu._cost) }}</td>
                  <td class="font-semibold">{{ menu._costPercentage == null ? '' : money(menu._costPercentage) + '%' }}</td>
                  <td>{{ money(menu.price) }}</td>
                  <td>{{ money(menu.addition) }}</td>
                  <td>{{ money(menu.vat) }}</td>
                  <td>{{ money(menu.totalPrice ?? menu.total_price) }}</td>
                  <!-- <td>{{ money(menu.price-menu._cost) }}</td> -->
                  <td>
                    <a
                      @click="openContingencyModal(menu)"
                      class="text-blue-500 cursor-pointer underline"
                    >
                      {{ menu.contingency ?? 10 }}
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
      </div>
    </div>

    <!-- Recipe Modal -->
    <div v-if="showModal" class="fixed inset-0 z-[1000] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 pr-1">
      <div class="bg-white rounded-xl shadow-2xl w-full max-w-3xl overflow-hidden animate-in zoom-in-95 duration-200 flex flex-col max-h-[90vh]">
        <!-- Modal Header -->
        <div class="px-6 py-4 bg-[#0d4169] text-white flex items-center justify-between shrink-0">
          <h3 class="text-sm font-bold tracking-wide">
            Recipe for: <span class="text-white/90">{{ selectedMenu?.name }}</span>
          </h3>
          <button @click="closeModalWithSave" class="w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/10 text-white transition-all text-2xl">&times;</button>
        </div>
        <!-- Modal Body -->
        <div class="p-6 pr-1 overflow-y-auto custom-scrollbar flex-1">
          <div v-if="itemsLoading" class="flex flex-col items-center justify-center py-12 gap-3">
            <!-- Circular Spinner -->
            <div
  v-if="itemsLoading"
  class="h-5 w-5 border-2 border-white/30 border-t-transparent rounded-full animate-spin"
></div>
            <span class="text-slate-500 text-sm font-medium">Loading recipe data...</span>
          </div>


        <div v-else>
          <div class="flex flex-col md:flex-row md:items-center gap-4 mt-1">
            <div class="flex items-center gap-2 md:min-w-[260px]">
              <label class="text-[0.78rem] font-semibold text-[#1e293b]">No. of Yield: </label>
              <input
                v-model="yieldCount"
                type="number"
                min="0"
                class="px-2.5 py-1 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm w-20"
              >
            </div>
            <!-- <div class="flex items-center justify-center md:px-3 md:mx-4">
             
            </div> -->
            <div class="flex items-center gap-2 flex-nowrap md:justify-start md:pr-2 md:min-w-0">
              <label class="text-[0.78rem] font-semibold text-[#1e293b] whitespace-nowrap">Recipe From Others: </label>
              <select
                v-model="selectedOtherRecipeId"
                class="px-2 py-1 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] text-sm bg-white cursor-pointer w-full md:w-auto md:min-w-[130px] max-w-full"
                @change="loadIngredientsFromOther"
              >
                <option value="">Select Recipe</option>
                <option v-for="r in otherRecipes" :key="r.id" :value="r.menuId">{{ r.name }}</option>
              </select>
            </div>
          </div>
          <hr class="my-3 border-slate-100">

          <div class="w-full">
            <!-- Inventory-like form style controls -->
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-4 gap-y-2 mb-4">
              <!-- 2 fields in one row -->
              <div class="sm:col-span-3 md:col-span-3">
                <div class="grid grid-cols-1 sm:grid-cols-4 gap-x-4 gap-y-2 items-end">
                  <div class="flex flex-col gap-1">
                    <label class="text-[0.78rem] font-semibold text-[#1e293b] text-left">Add Ingredient</label>
                    <select
                      v-model="addIngredientItemId"
                      class="px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm bg-white cursor-pointer"
                      @change="onIngredientSelect"
                    >
                      <option value="">Choose Ingredient</option>
                      <option v-for="opt in ingredientOptions" :key="opt.type + opt.id" :value="opt.type + ':' + opt.id" :class="{ 'bg-emerald-100 font-bold': opt.type === 'product' }">
                        {{ getIngredientOptionLabel(opt) }}
                      </option>
                    </select>
                  </div>

                  <div class="flex flex-col gap-1">
                    <label class="text-[0.78rem] font-semibold text-[#1e293b] text-left">Quantity</label>
                    <input
                      v-model="addQuantity"
                      type="number"
                      min="0"
                      step="1"
                      placeholder="0"
                      class="px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm"
                    >
                  </div>

                  <div class="flex flex-col gap-1">
                    <label class="text-[0.78rem] font-semibold text-[#1e293b] text-left">Remark</label>
                    <input
                      v-model="addRemark"
                      type="text"
                      class="px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm"
                      placeholder="Row remark"
                    >
                  </div>

                  <div class="flex flex-col gap-1">
                    <label class="text-[0.78rem] font-semibold text-transparent">Action</label>
                    <div class="flex items-center gap-2">
                      <button
                        type="button"
                        :disabled="!canSubmitRecipeIngredient"
                        class="w-fit px-4 py-1.5 bg-[#0d4169] text-white text-sm font-bold rounded-md shadow-md transition-all active:scale-95"
                        :class="canSubmitRecipeIngredient ? 'hover:bg-[#0a3354]' : 'opacity-50 cursor-not-allowed'"
                        @click="saveIngredient"
                      >
                        {{ editingIndex === -1 ? 'Add' : 'Update' }}
                      </button>
                      <button
                        type="button"
                        class="ml-4 px-4 py-1.5 bg-emerald-600 text-white text-sm font-bold rounded-md shadow-md transition-all active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 whitespace-nowrap"
                        :class="canSaveRecipeNotes ? 'hover:bg-emerald-700' : 'opacity-50 cursor-not-allowed'"
                        @click="saveRecipeToBackend"
                        :disabled="recipeSaving || !canSaveRecipeNotes"
                      >
                        <div
                          v-if="recipeSaving"
                          class="h-5 w-5 border-2 border-white/30 border-t-transparent rounded-full animate-spin"
                        ></div>
                        <span v-if="!recipeSaving">Save</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="w-full overflow-x-auto">
            <!-- Structure aligned to pro1 final.html -->
            <table class="recipe-table">
              <thead>
                <tr>
                  <th>Ingredient Name</th>
                  <th>U.O.M</th>
                  <th>Quantity</th>
                  <th>U.P</th>
                  <th>Total Price</th>
                  <th>Remark</th>
                  <th>Active</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, idx) in recipeRows" :key="idx" class="hover:bg-slate-100/50 transition-colors border-b">
                  <td :class="['font-semibold', row.type === 'product' ? 'text-emerald-600' : '']">
                    {{ row.ingredient }}
                  </td>
                  <td>{{ getRecipeModalDisplayUom(row) }}</td>
                  <td>{{ row.qty }}</td>
                  <td>{{ money(getRecipeModalDisplayUp(row)) }}</td>
                  <td class="font-bold">{{ money(getRecipeModalDisplayTotal(row)) }}</td>
                  <td>{{ row.remark }}</td>
                  <td class="text-center">
                    <div
                      class="toggle-switch"
                      :class="canEditRecipe ? '' : 'cursor-not-allowed opacity-50'"
                      @click="toggleActive(row)"
                    >
                      <span class="toggle-slider" :class="{ 'active': row.isActive }"></span>
                    </div>
                  </td>
                  <td class="text-slate-500">
                    <a
                      @click="editRow(idx)"
                      class="text-blue-500 px-2 py-1.5 transition-all active:scale-95"
                      :class="canEditRecipe ? 'cursor-pointer' : 'opacity-50 cursor-not-allowed'"
                    >Edit</a>
                    <a
                      @click="deleteRow(idx)"
                      class="text-red-500 px-2 py-1.5 transition-all active:scale-95"
                      :class="canEditRecipe ? 'cursor-pointer' : 'opacity-50 cursor-not-allowed'"
                    >Delete</a>
                  </td>
                </tr>

                <!-- Summary rows as in the reference html -->
                <tr class="border-t">
                  <td class="font-semibold">Cost Sub Total</td>
                  <td class="font-bold">{{ money(costSubTotal) }}</td>
                  <td colspan="6"></td>
                </tr>
                <tr>
                  <td class="font-semibold">Contingency {{ selectedMenu?.contingency ?? 10 }}%</td>
                  <td class="font-bold">{{ money(contingencyAmount) }}</td>
                  <td colspan="6"></td>
                </tr>
                <tr>
                  <td class="font-semibold">Total Cost</td>
                  <td class="font-bold">{{ money(totalCost) }}</td>
                  <td colspan="6"></td>
                </tr>
                <tr>
                  <td class="font-semibold">Cost Per Unit</td>
                  <td class="font-bold">{{ money(costPerUnit) }}</td>
                  <td colspan="6"></td>
                </tr>
                <tr>
                  <td class="font-semibold">Cost Percentage %</td>
                  <td class="font-bold">{{ money(costPercentage) }}%</td>
                  <td colspan="6"></td>
                </tr>
                <tr>
                  <td class="font-semibold">Original Selling Price</td>
                  <td class="font-bold">{{ money(originalSellingPrice) }}</td>
                  <td colspan="6"></td>
                </tr>

                <!-- <tr>
                  <td class="font-semibold">Profit in Birr</td>
                  <td class="font-bold">{{ money(originalSellingPrice-costPerUnit) }}</td>
                  <td colspan="6"></td>
                </tr> -->
                <tr>
                  <td class="font-semibold">Additional {{((additionalAmount/originalSellingPrice)*100).toFixed(2)}}%</td>
                  <td class="font-bold">{{ money(additionalAmount) }}</td>
                  <td colspan="6"></td>
                </tr>
                <tr>
                  <td class="font-semibold">VAT {{((vatAmount/(originalSellingPrice+additionalAmount))*100).toFixed(2)}}%</td>
                  <td class="font-bold">{{ money(vatAmount) }}</td>
                  <td colspan="6"></td>
                </tr>
                <tr class="bg-slate-50">
                  <td class="font-bold text-[#0d4169]">Total Selling Price</td>
                  <td class="font-bold text-[#0d4169]">{{ money(totalSellingPrice) }}</td>
                  <td colspan="6"></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="mt-4 flex gap-3">
            <div class="flex-1 max-w-[50%]">
              <label class="block text-[0.78rem] font-semibold text-[#1e293b] mb-1 text-left">Remarks / Notes:</label>
              <textarea
                v-model="remark"
                rows="3"
                class="w-full px-2.5 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm resize-y"
                placeholder="Enter any additional notes here..."
              ></textarea>
            </div>

            <div class="flex items-center justify-end flex-1"></div>
          </div>
        </div>
      </div>
      </div>
    </div>

    <!-- Contingency Modal -->
    <div v-if="showContingencyModal" class="fixed inset-0 z-[1100] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4">
      <div class="bg-white rounded-xl shadow-2xl w-full max-w-sm overflow-hidden animate-in zoom-in-95 duration-200">
        <!-- Modal Header -->
        <div class="px-5 py-3 bg-[#0d4169] text-white flex items-center justify-between">
          <h3 class="text-sm font-bold tracking-wide">Edit Contingency</h3>
          <button @click="closeContingencyModal" class="w-7 h-7 flex items-center justify-center rounded-full hover:bg-white/10 text-white transition-all text-xl">&times;</button>
        </div>
        <div class="p-6">
          <h3 class="text-lg font-bold text-[#0d4169] mb-4">Edit Contingency</h3>
          <div class="flex flex-col gap-3">
            <div>
              <label class="text-[0.78rem] font-semibold text-[#1e293b] text-left">Contingency Value(%)</label>
              <input
                v-model="contingencyValue"
                type="number"
                step="0.01"
                class="w-full px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm mt-1"
                placeholder="Enter contingency value"
              >
            </div>
            <div class="flex justify-end gap-3 mt-5">
              <button
                type="button"
                class="px-4 py-1.5 bg-slate-200 text-slate-700 text-sm font-bold rounded-md hover:bg-slate-300 transition-all"
                @click="closeContingencyModal"
              >
                Cancel
              </button>
              <button
                type="button"
                class="px-4 py-1.5 bg-[#0d4169] text-white text-sm font-bold rounded-md hover:bg-[#0a3354] transition-all"
                @click="saveContingency"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Toast Notification -->
  <Transition name="toast">
    <div v-if="toast.show" class="fixed top-4 right-4 z-[1000] max-w-sm">
      <div :class="[
        'px-4 py-3 rounded-lg shadow-lg text-white font-semibold',
        toast.type === 'success' ? 'bg-green-500' : 'bg-red-500'
      ]">
        {{ toast.message }}
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { computed, onMounted, reactive, ref } from 'vue'
// import { useRouter } from 'vue-router'
import store from '../../../store'
import { apiFetch } from '../../../utils/api'

// const router = useRouter()

const menus = ref([])
const departments = ref([])
const items = ref([])

const loading = ref(false)
const itemsLoading = ref(false)
const menuCostsLoading = ref(false)
const selectedDepartmentId = ref('')
const menuSearchQuery = ref('')
const showModal = ref(false)
const isTable = ref(false)

const yieldCount = ref(1)
const remark = ref('')
const editingIndex = ref(-1)

const addIngredient = ref('')
const addIngredientItemId = ref('')
const addQuantity = ref('')
const addUom = ref('Kg')
const addUP = ref(0)
const addRemark = ref('')
const recipeSaving = ref(false)

const showContingencyModal = ref(false)
const editingContingencyMenuId = ref(null)
const contingencyValue = ref('')

const menuData = ref([])
const filteredMenuData = computed(() => {
  const query = String(menuSearchQuery.value || '').trim().toLowerCase()
  if (!query) return menuData.value
  return menuData.value.filter((menu) =>
    String(menu?.name || '').toLowerCase().includes(query)
  )
})

const ingredientOptions = ref([])
const DEFAULT_PRODUCT_CONTINGENCY = 5

const currentUser = computed(() => store.getters.currentUser)
const companyId = computed(() => currentUser.value?.companyId || currentUser.value?.company_id || currentUser.value?.company?.id || null)
const branchId = computed(() => currentUser.value?.branchId || currentUser.value?.branch_id || currentUser.value?.branch?.id || null)
const userPrivileges = computed(() => {
  if (!currentUser.value?.privilege) return {}
  return typeof currentUser.value.privilege === 'string'
    ? JSON.parse(currentUser.value.privilege)
    : currentUser.value.privilege
})
const hasAdminPrivilege = computed(() => userPrivileges.value?.All === true || userPrivileges.value?.all === true)
function getPrivilegeBlock(name) {
  return userPrivileges.value?.[name] || userPrivileges.value?.[String(name).toLowerCase()] || null
}
const recipePrivilege = computed(() => getPrivilegeBlock('Recipe'))
const canAddRecipe = computed(() => {
  if (hasAdminPrivilege.value) return true
  return !!recipePrivilege.value?.Add
})
const canEditRecipe = computed(() => {
  if (hasAdminPrivilege.value) return true
  return !!recipePrivilege.value?.Edit
})
const canSubmitRecipeIngredient = computed(() => (
  editingIndex.value === -1 ? canAddRecipe.value : canEditRecipe.value
))
const canSaveRecipeNotes = computed(() => canAddRecipe.value || canEditRecipe.value)

const selectedMenu = ref(null)

const otherRecipes = ref([])
const selectedOtherRecipeId = ref('')

async function loadOtherRecipes() {
  if (!companyId.value && !branchId.value) return
  try {
    const params = new URLSearchParams()
    if (branchId.value) params.append('branchId', branchId.value)
    else if (companyId.value) params.append('companyId', companyId.value)

    const res = await apiFetch(`/recipes/all-with-menus?${params.toString()}`, { method: 'GET' })
    if (!res.ok) return
    const data = await res.json().catch(() => [])
    // Exclude currently selected menu
    otherRecipes.value = Array.isArray(data)
      ? data.filter(r => Number(r.menuId) !== Number(selectedMenu.value?.id))
      : []
  } catch (err) {
    console.error('Error loading other recipes:', err)
  }
}

const recipeRows = ref([
 
])
const deletedIngredientIds = ref([])

// Toast notification state
const toast = ref({ show: false, message: '', type: 'success' })

const costSubTotal = computed(() =>
  recipeRows.value.reduce((sum, r) => sum + Number(getRecipeModalDisplayTotal(r) || 0), 0)
)

const contingencyAmount = computed(() => {
  const percentage = Number(selectedMenu.value?.contingency ?? 10) / 100;
  return costSubTotal.value * percentage;
})
const totalCost = computed(() => costSubTotal.value + contingencyAmount.value)
const costPerUnit = computed(() => {
  const y = Number(yieldCount.value || 0)
  if (!y) return 0
  return totalCost.value / y
})

const costPercentage = computed(() => {
  const price = Number(selectedMenu.value?.price ?? 0)
  if (!price) return 0
  return (costPerUnit.value / price) * 100
})

// Use values from selected menu for selling price breakdown
const originalSellingPrice = computed(() => Number(selectedMenu.value?.price ?? 0))
const additionalAmount = computed(() => Number(selectedMenu.value?.addition ?? 0))
const vatAmount = computed(() => Number(selectedMenu.value?.vat ?? 0))
const totalSellingPrice = computed(() =>
  Number(selectedMenu.value?.totalPrice ?? selectedMenu.value?.total_price ?? 0)
)

function money(val) {
  const num = Number(val || 0)
  return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

function normalizeUnit(u) {
  return String(u ?? '')
    .trim()
    .toLowerCase()
    .replace(/\./g, '')
    .replace(/\s+/g, '')
}

function isKgOrLiter(u) {
  const unitNorm = normalizeUnit(u)
  return unitNorm === 'kg' || unitNorm === 'liter'
}

function isMlOrGram(u) {
  const unitNorm = normalizeUnit(u)
  return unitNorm === 'ml' || unitNorm === 'milliliter' || unitNorm === 'gram'
}

function isPieces(u) {
  const unitNorm = normalizeUnit(u)
  return unitNorm === 'piece' || unitNorm === 'pieces' || unitNorm === 'pc' || unitNorm === 'pcs'
}

function isBottle(u) {
  const unitNorm = normalizeUnit(u)
  return unitNorm === 'bottle' || unitNorm === 'bottles' || unitNorm === 'btl'
}

function isGlass(u) {
  const unitNorm = normalizeUnit(u)
  return unitNorm === 'glass' || unitNorm === 'glasses'
}

function computeUpFromRecentPriceAndVolume(unit, unitProduction, recentUnitPrice, recentVolume) {
  const up = Number(recentUnitPrice ?? 0)
  const vol = Number(recentVolume ?? 0)
  if (!(Number.isFinite(up) && Number.isFinite(vol) && vol > 0)) return null

  // Requirement (modal only):
  // if unit is liter/K.G. AND unitProduction is M.L./Gram =>
  // U.P = (recent_unit_price / recent_volume) * 1000
  if (isKgOrLiter(unit) && isMlOrGram(unitProduction)) {
    return (up / vol) * 1000
  }
  return null
}

function computeItemModalDisplayUp(unit, unitProduction, recentUnitPrice, recentVolume, glassAmount) {
  const up = Number(recentUnitPrice ?? 0)
  const vol = Number(recentVolume ?? 0)
  if (!(Number.isFinite(up) && Number.isFinite(vol) && vol > 0)) return null

  // Existing rule:
  // unit is liter/kg and unitProduction is ml/gram => multiply by 1000
  if (isKgOrLiter(unit) && isMlOrGram(unitProduction)) {
    return (up / vol) * 1000
  }

  // New rule:
  // unit is liter/kg and unitProduction is glass => multiply by glass amount
  if (isKgOrLiter(unit) && isGlass(unitProduction)) {
    const g = Number(glassAmount ?? 0)
    if (Number.isFinite(g) && g > 0) {
      return (up / vol) * g
    }
    return null
  }

  if (isPieces(unit)) {
    // Pieces + ml/gram => multiply by 1000
    if (isMlOrGram(unitProduction)) {
      return (up / vol) * 1000
    }
    // Pieces + bottle => direct per-volume rate
    if (isBottle(unitProduction)) {
     
      return up / vol
    }
    // Pieces + glass => multiply by glass amount
    if (isGlass(unitProduction)) {
      const g = Number(glassAmount ?? 0)
      if (Number.isFinite(g) && g > 0) {
        return (up / vol) * g
      }
      return null
    }
    // Pieces + pieces => use recent unit price directly
    if (isPieces(unitProduction)) {
      return up
    }
  }

  return null
}

// Display-only U.P logic for the "Recipe for" modal.
// IMPORTANT:
// - For items/products where unit is liter/kg AND unitProduction is ML/Gram,
//   show U.P as (recent_unit_price / recent_volume) * 1000.
// - For product rows with fetchProductCost fallback, keep existing behavior (no conversion here).
// Note: This does NOT mutate row.up or row.total (we adjust totals in getRecipeModalDisplayTotal).
function getRecipeModalDisplayUp(row) {
  if (!row) return 0
  const baseUp = Number(row.up || 0)

  if (row.type === 'item') {
    const item = items.value.find(it => String(it.id) === String(row.itemId))
    const itemUnit = item?.unit ?? ''
    const itemUnitProduction = item?.unitProduction ?? row.uom ?? ''
    const itemGlassAmount = item?.glass_amount ?? item?.glassAmount ?? null
    const derived = computeItemModalDisplayUp(
      itemUnit,
      itemUnitProduction,
      item?.recent_unit_price ?? item?.recentPrice ?? item?.recentUnitPrice ?? null,
      item?.recent_volume ?? item?.recentVolume ?? null,
      itemGlassAmount
    )
    return derived != null ? derived : baseUp
  }

  if (row.type === 'product') {
    // If U.P came from fetchProductCost fallback, the value is already in the "display unit"
    // expected by the modal totals; do not apply KG/liter => Gram/ML conversion.
    if (row.upFromFetchProductCost) return baseUp

    const opt = ingredientOptions.value.find(o => o.type === 'product' && String(o.id) === String(row.productId))
    const productUnit = row.uom || opt?.uom || ''
    const productUnitProduction = getRecipeModalDisplayUom(row)
    const derived = computeUpFromRecentPriceAndVolume(
      productUnit,
      productUnitProduction,
      row.recent_unit_price ?? opt?.recent_unit_price ?? null,
      row.recent_volume ?? opt?.recent_volume ?? null
    )
    return derived != null ? derived : baseUp
  }

  return baseUp
}

// Display-only Total Price conversion for the "Recipe for" modal.
// Rule:
// - Only for product rows where U.P was calculated via fetchProductCost (upFromFetchProductCost = true)
// - If product U.O.M is kg/liter => display total as row.total / 1000
// Note: does NOT mutate row.total.
function getRecipeModalDisplayTotal(row) {
  if (!row) return 0

  const normalizeUnit = (u) => String(u ?? '')
    .trim()
    .toLowerCase()
    .replace(/\./g, '')
    .replace(/\s+/g, '')

  const isDisplayedMlOrGram = (u) => {
    const unitNorm = normalizeUnit(u)
    return unitNorm === 'ml' || unitNorm === 'milliliter' || unitNorm === 'gram'
  }

  const displayUom = getRecipeModalDisplayUom(row)
  const shouldDivideBy1000 = isDisplayedMlOrGram(displayUom)

  // For normal rows (items + products with recent_unit_price),
  // compute display total from the display U.P to keep modal totals consistent.
  // For product rows with fetchProductCost fallback, use persisted row.total as source.
  if (!(row.type === 'product' && row.upFromFetchProductCost)) {
    const qty = Number(row.qty || 0)
    const total = qty * Number(getRecipeModalDisplayUp(row) || 0)
    return shouldDivideBy1000 ? total / 1000 : total
  }

  const baseTotal = Number(row.total || 0)
  return shouldDivideBy1000 ? baseTotal / 1000 : baseTotal
}

// Display-only U.O.M conversion for the "Recipe for" modal (product rows only).
// Requirement:
// - If product uom is "K.G." => display "Gram"
// - If product uom is "liter" => display "M.L."
// Note: does NOT mutate row.uom.
function getRecipeModalDisplayUom(row) {
  if (!row) return ''
  if (row.type !== 'product') return row.uom ?? ''

  const normalizeUnit = (u) => String(u ?? '')
    .trim()
    .toLowerCase()
    .replace(/\./g, '')
    .replace(/\s+/g, '')

  const unitNorm = normalizeUnit(row.uom)

  const isKg = unitNorm === 'kg'
  const isLiter = unitNorm === 'liter'

  if (isKg) return 'Gram'
  if (isLiter) return 'M.L.'

  return row.uom ?? ''
}

/** Dropdown label only: products show (Debo)/(pro); items unchanged. */
function getIngredientOptionLabel(opt) {
  if (!opt) return ''
  if (opt.type !== 'product') return opt.name || ''
  return `${opt.name || ''} (${opt.isDebone ? 'Debo' : 'pro'})`
}

function getSavedMenuRecipeScale(row) {
  if (!row) return 1
  if (row.type === 'item') {
    const item = items.value.find(it => String(it.id) === String(row.itemId))
    const itemUnitProduction = item?.unitProduction ?? row.uom ?? ''
    return isMlOrGram(itemUnitProduction) ? 1000 : 1
  }
  if (row.type === 'product') {
    const productUom = row.uom ?? ''
    return isKgOrLiter(productUom) ? 1000 : 1
  }
  return 1
}

function buildSavedMenuRecipeIngredientAmounts() {
  const numberYield = Number(yieldCount.value || 0)
  const safeYield = numberYield > 0 ? numberYield : 1

  return recipeRows.value.map((row) => {
    const scale = getSavedMenuRecipeScale(row)
    const qty = Number(row.qty || 0)
    const amount = qty / safeYield / (scale || 1)
    const id = row.type === 'product'
      ? Number(row.productId || 0)
      : Number(row.itemId || 0)

    return {
      Id: id,
      amount: Number(amount.toFixed(6)),
      type: row.type === 'product' ? 'Product' : 'Item'
    }
  }).filter((entry) => Number(entry.Id) > 0)
}

// Toast helper function
function showToast(message, type = 'success') {
  toast.value = { show: true, message, type }
  setTimeout(() => {
    toast.value.show = false
  }, 3000) // Hide after 3 seconds
}

async function loadMenus() {
  if (!companyId.value && !branchId.value) return
  loading.value = true
  try {
    const params = new URLSearchParams()
    if (branchId.value) params.append('branchId', branchId.value)
    else if (companyId.value) params.append('companyId', companyId.value)

    const response = await apiFetch(`/menu-lists?${params.toString()}`, { method: 'GET' })
    if (!response.ok) return
    const data = await response.json().catch(() => [])
    menus.value = Array.isArray(data)
      ? data.filter(m => (m.status ?? 1) === 1 && (m.department?.status ?? 1) === 1)
      : []
  } catch (err) {
    console.error('Error loading menus:', err)
  } finally {
    loading.value = false
  }
}

async function loadDepartmentsForRecipe() {
  if (!companyId.value && !branchId.value) return
  try {
    let endpoint = `/departments/company/${companyId.value}`
    if (branchId.value) {
      endpoint = `/departments/branch/${branchId.value}`
    }
    const response = await apiFetch(endpoint, { method: 'GET' })
    if (!response.ok) return
    const data = await response.json().catch(() => [])
    departments.value = Array.isArray(data)
      ? data.filter(d => (d.status ?? 1) === 1)
      : []
    departments.value.sort((a, b) => String(a.name || '').localeCompare(String(b.name || ''), undefined, { sensitivity: 'base' }))
  } catch (err) {
    console.error('Error loading departments for recipe:', err)
  }
}

async function loadItemsForRecipe() {
  if (!companyId.value && !branchId.value) return
  try {
    itemsLoading.value = true
    const params = new URLSearchParams()
    if (branchId.value) params.append('branchId', branchId.value)
    else if (companyId.value) params.append('companyId', companyId.value)

    const response = await apiFetch(`/items?${params.toString()}`, { method: 'GET' })
    if (!response.ok) return
    const data = await response.json().catch(() => [])
    const activeItems = Array.isArray(data)
      ? data.filter(i => (i.status ?? 1) === 1)
      : []
    items.value = activeItems
    
    // Only map items that are explicitly set as an ingredient
    ingredientOptions.value = activeItems
      .filter(i =>
        i.isIngredient === 1 || i.isIngredient === '1' ||
        i.is_ingredient === 1 || i.is_ingredient === '1'
      )
      .map(i => ({
        id: i.id,
        name: i.itemName,
        uom: i.unitProduction || i.unit,
        up: Number(i.recent_unit_price ?? i.recentPrice ?? i.recentUnitPrice ?? 0),
        recent_unit_price: i?.recent_unit_price ?? null,
        recent_volume: i?.recent_volume ?? null,
        glass_amount: i?.glass_amount ?? i?.glassAmount ?? null,
        type: 'item'
      }))

    // Load Products (+ debone-linked IDs for dropdown label only)
    const [prodResponse, deboneLinkedRes] = await Promise.all([
      apiFetch(`/products?${params.toString()}`, { method: 'GET' }),
      apiFetch('/products?deboneLinked=true', { method: 'GET' })
    ])
    const deboneLinkedIds = new Set()
    if (deboneLinkedRes.ok) {
      const deboneLinkedData = await deboneLinkedRes.json().catch(() => [])
      if (Array.isArray(deboneLinkedData)) {
        for (const p of deboneLinkedData) {
          if (p?.id != null) deboneLinkedIds.add(Number(p.id))
        }
      }
    }
    if (prodResponse.ok) {
      const prodData = await prodResponse.json().catch(() => [])
      const activeProducts = Array.isArray(prodData) ? prodData.filter(p => (p.status == 1 || p.status === undefined)) : []
      const productOptions = activeProducts.map(p => {
        const recentUp = Number(
          p.recent_unit_price ??
          p.recentUnitPrice ??
          p.recentPrice ??
          0
        )
        const opt = reactive({
          id: p.id,
          name: p.name,
          uom: p.uom || p.unitProduction || p.unit || 'Pc',
          // Prefer product recent_unit_price for modal U.P.
          // If missing/0, fallback to recipe-based cost via fetchProductCost().
          up: recentUp,
          type: 'product',
          quantity: Number(p.quantity || 1),
          contingency: p.contingency ?? DEFAULT_PRODUCT_CONTINGENCY,
          recent_unit_price: p?.recent_unit_price ?? null,
          recent_volume: p?.recent_volume ?? null,
          isDebone: deboneLinkedIds.has(Number(p.id)),
        })
        if (!recentUp) {
          fetchProductCost(p.id, opt.quantity).then(cost => {
            opt.up = cost
          })
        }
        return opt
      })
      ingredientOptions.value = [...ingredientOptions.value, ...productOptions].sort((a, b) => a.name.localeCompare(b.name))
    }
  } catch (err) {
    console.error('Error loading items for recipe:', err)
  } finally {
    itemsLoading.value = false
  }
}

async function handleDepartmentSelected() {
  if (!selectedDepartmentId.value) {
    menuData.value = []
    isTable.value = false
    return
  }

  const depId = Number(selectedDepartmentId.value)
  const filtered = menus.value.filter(m => {
    const dId = m.departmentId ?? m.department_id ?? m.department?.id
    if (!dId) return false
    return Number(dId) === depId
  })

  menuData.value = filtered
  menuData.value.sort((a, b) => a.name.localeCompare(b.name))
  isTable.value = filtered.length > 0

  if (filtered.length > 0) {
    await loadRecipesAndCostsForMenus(filtered)
  }
}

async function computeCostFromRecipe(recipeData, menu) {
  const ings = Array.isArray(recipeData?.ingredients) ? recipeData.ingredients : []
  const numberYield = Number(recipeData?.numberYield ?? recipeData?.number_yield ?? 1) || 1
  const contingencyPct = Number(menu?.contingency ?? 10) / 100

  let costSubTotalLocal = 0

  const normalizeUnit = (u) => String(u ?? '')
    .trim()
    .toLowerCase()
    .replace(/\./g, '')
    .replace(/\s+/g, '')

  const getProductDisplayUom = (u) => {
    const unitNorm = normalizeUnit(u)
    if (unitNorm === 'kg') return 'Gram'
    if (unitNorm === 'liter') return 'M.L.'
    return u ?? ''
  }

  for (const i of ings) {
    const productId = i.productId || i.product_id || i.product?.id
    const itemId = i.itemId ?? i.item_id ?? i.item?.id
    const type = i.type || (productId ? 'product' : 'item')
    let up = 0
    let upFromFetchProductCost = false
    const qty = Number(i.quantity || 0)

    if (type === 'product') {
      // Match modal logic: use product recent_unit_price first.
      // If backend didn't provide it (or it's 0), fallback to recipe-based cost.
      up = Number(
        i.product?.recent_unit_price ??
        i.product?.recentUnitPrice ??
        i.product?.recentPrice ??
        0
      )
      if (!up && productId) {
        up = await fetchProductCost(productId)
        upFromFetchProductCost = true
      }

      const productUom = i.product?.uom || i.uom || ''
      const productDisplayUom = getProductDisplayUom(productUom)

      if (!upFromFetchProductCost) {
        // Match modal U.P display conversion for product rows with recent_unit_price.
        const derived = computeUpFromRecentPriceAndVolume(
          productUom,
          productDisplayUom,
          i.product?.recent_unit_price ?? i.product?.recentUnitPrice ?? i.product?.recentPrice ?? null,
          i.product?.recent_volume ?? i.product?.recentVolume ?? null
        )
        if (derived != null) up = derived
      }

      // Match modal total display for product rows:
      // if displayed U.O.M is Gram/M.L., divide by 1000 once.
      const total = qty * up
      if (isMlOrGram(productDisplayUom)) {
        costSubTotalLocal += total / 1000
      } else {
        costSubTotalLocal += total
      }
      continue
    }

    const fullItem = items.value.find(it => String(it.id) === String(itemId))
    const itemUnit = fullItem?.unit ?? i.item?.unit ?? ''
    const itemUnitProduction = fullItem?.unitProduction ?? i.item?.unitProduction ?? i.unit ?? ''
    const itemRecentUnitPrice = fullItem?.recent_unit_price ?? fullItem?.recentPrice ?? fullItem?.recentUnitPrice ?? i.item?.recent_unit_price ?? i.item?.recentPrice ?? i.item?.recentUnitPrice ?? 0
    const itemRecentVolume = fullItem?.recent_volume ?? fullItem?.recentVolume ?? i.item?.recent_volume ?? i.item?.recentVolume ?? null
    const itemGlassAmount =
      fullItem?.glass_amount ??
      fullItem?.glassAmount ??
      i.item?.glass_amount ??
      i.item?.glassAmount ??
      null

    up = Number(itemRecentUnitPrice)
    const derivedItemUp = computeItemModalDisplayUp(
      itemUnit,
      itemUnitProduction,
      itemRecentUnitPrice,
      itemRecentVolume,
      itemGlassAmount
    )
    if (derivedItemUp != null) up = derivedItemUp

    // Match modal total display rule generally:
    // if displayed U.O.M is Gram/M.L., divide total by 1000.
    const itemTotal = qty * up
    if (isMlOrGram(itemUnitProduction)) {
      costSubTotalLocal += itemTotal / 1000
    } else {
      costSubTotalLocal += itemTotal
    }
  }

  const contingencyAmountLocal = costSubTotalLocal * contingencyPct
  const totalCostLocal = costSubTotalLocal + contingencyAmountLocal
  const costPerUnitLocal = numberYield > 0 ? totalCostLocal / numberYield : 0
  const priceLocal = Number(menu?.price ?? 0)
  const costPercentageLocal = priceLocal > 0 ? (costPerUnitLocal / priceLocal) * 100 : 0

  return { costPerUnit: costPerUnitLocal, costPercentage: costPercentageLocal }
}

async function loadRecipesAndCostsForMenus(menus) {
  if (!menus?.length) return
  menuCostsLoading.value = true
  try {
    const params = new URLSearchParams()
    if (branchId.value) params.append('branchId', branchId.value)
    else if (companyId.value) params.append('companyId', companyId.value)
    params.append('menuIds', menus.map((m) => m.id).join(','))

    const res = await apiFetch(`/recipe-menu-costs?${params.toString()}`, { method: 'GET' })
    if (!res.ok) {
      await loadRecipesAndCostsForMenusLegacy(menus)
      return
    }

    const data = await res.json().catch(() => [])
    const costByMenuId = new Map()
    for (const row of (Array.isArray(data) ? data : [])) {
      costByMenuId.set(Number(row.menuId), row)
    }

    for (const menu of menus) {
      const row = costByMenuId.get(Number(menu.id))
      if (!row || row.costPerUnit == null) {
        menu._cost = null
        menu._costPercentage = null
      } else {
        menu._cost = Number(row.costPerUnit ?? 0)
        menu._costPercentage = Number(row.costPercentage ?? 0)
      }
    }
  } catch (err) {
    console.error('Error loading recipe menu costs:', err)
    await loadRecipesAndCostsForMenusLegacy(menus)
  } finally {
    menuCostsLoading.value = false
  }
}

async function loadRecipesAndCostsForMenusLegacy(menus) {
  if (!menus?.length) return
  if (items.value.length === 0) await loadItemsForRecipe()
  try {
    for (const menu of menus) {
      menu._cost = null
      menu._costPercentage = null
      try {
        const res = await apiFetch(`/recipes/menu/${menu.id}`, { method: 'GET' })
        if (!res.ok) continue
        const data = await res.json().catch(() => null)
        if (!data) continue
        const ings = Array.isArray(data.ingredients) ? data.ingredients : []
        if (!ings.length) continue
        const { costPerUnit, costPercentage } = await computeCostFromRecipe(data, menu)
        menu._cost = costPerUnit
        menu._costPercentage = costPercentage
      } catch {
        // leave empty when recipe/ingredients cannot be loaded
      }
    }
  } catch (err) {
    console.error('Error loading recipe costs (legacy):', err)
  }
}

async function loadRecipeForSelectedMenu() {
  if (!selectedMenu.value?.id) return
  try {
    const res = await apiFetch(`/recipes/menu/${selectedMenu.value.id}`, { method: 'GET' })
    if (!res.ok) {
      recipeRows.value = []
      yieldCount.value = 1
      remark.value = ''
      return
    }
    const data = await res.json().catch(() => null)
    if (!data) return

    yieldCount.value = Number(data.numberYield ?? data.number_yield ?? 1) || 1
    remark.value = data.notes ?? ''

    const ings = Array.isArray(data.ingredients) ? data.ingredients : []
    // Fresh data loaded from DB, so reset any staged deletions.
    deletedIngredientIds.value = []
    // Match ProductPage: prefer product recent_unit_price, fallback to fetchProductCost.
    recipeRows.value = await buildRecipeCostRowsFromApiIngredients(ings)
  } catch (err) {
    console.error('Error loading recipe:', err)
  }
}

async function openRecipeModal(menu) {
  selectedMenu.value = menu
  showModal.value = true
  itemsLoading.value = true
  try {
    // Match ProductPage: ensure ingredient options are loaded before building modal rows.
    if (items.value.length === 0 || ingredientOptions.value.length === 0) {
      await loadItemsForRecipe()
    }
    await loadRecipeForSelectedMenu()
    await loadOtherRecipes()
  } finally {
    itemsLoading.value = false
  }
}

async function saveRecipeToBackend() {
  if (!canSaveRecipeNotes.value) return
  if (!selectedMenu.value?.id) return
  recipeSaving.value = true
  try {
    const payload = {
      numberYield: Number(yieldCount.value || 1),
      notes: remark.value || '',
    }
    const res = await apiFetch(`/recipes/menu/${selectedMenu.value.id}/details`, {
      method: 'PUT',
      body: JSON.stringify(payload),
    })
    if (!res.ok) {
      const err = await res.json().catch(() => ({}))
      showToast(err.message || 'Failed to save recipe details', 'error')
      return
    }

    // Persist staged deletions first.
    for (const ingredientId of deletedIngredientIds.value) {
      const delRes = await apiFetch(`/recipes/ingredient/${ingredientId}`, {
        method: 'DELETE',
      })
      if (!delRes.ok) {
        const err = await delRes.json().catch(() => ({}))
        throw new Error(err.message || 'Failed to delete ingredient')
      }
    }
    deletedIngredientIds.value = []

    // Persist all ingredients currently listed in the modal.
    // - Existing rows (with id): update
    // - New rows (without id): create
    for (const row of recipeRows.value) {
      const payload = {
        itemId: row.type === 'item' ? Number(row.itemId || 0) : null,
        productId: row.type === 'product' ? Number(row.productId || 0) : null,
        type: row.type,
        quantity: Number(row.qty || 0),
        unit: row.uom || '',
        isActive: row.isActive ? 1 : 0,
        remark: row.remark || null,
      }

      if (row.id) {
        const updateRes = await apiFetch(`/recipes/ingredient/${row.id}`, {
          method: 'PUT',
          body: JSON.stringify(payload),
        })
        if (!updateRes.ok) {
          const err = await updateRes.json().catch(() => ({}))
          throw new Error(err.message || 'Failed to update ingredient')
        }
      } else {
        const addRes = await apiFetch(`/recipes/menu/${selectedMenu.value.id}/ingredient`, {
          method: 'POST',
          body: JSON.stringify(payload),
        })
        if (!addRes.ok) {
          const err = await addRes.json().catch(() => ({}))
          throw new Error(err.message || 'Failed to add ingredient')
        }
      }
    }

    const snapshotPayload = {
      numberYield: Number(yieldCount.value || 1),
      ingredientAndAmount: buildSavedMenuRecipeIngredientAmounts()
    }
    const snapshotRes = await apiFetch(`/recipes/menu/${selectedMenu.value.id}/saved-menu-recipe`, {
      method: 'POST',
      body: JSON.stringify(snapshotPayload),
    })
    if (!snapshotRes.ok) {
      const err = await snapshotRes.json().catch(() => ({}))
      throw new Error(err.message || 'Failed to save menu recipe snapshot')
    }

    showToast('Recipe details saved successfully', 'success')
    await loadRecipeForSelectedMenu()
    // Refresh table cost for this menu (match modal contingency)
    if (!recipeRows.value.length) {
      selectedMenu.value._cost = null
      selectedMenu.value._costPercentage = null
    } else {
      const sub = costSubTotal.value
      const total = sub + contingencyAmount.value
      const y = Number(yieldCount.value || 1) || 1
      const cp = Number(selectedMenu.value?.price ?? 0)
      selectedMenu.value._cost = y > 0 ? total / y : 0
      selectedMenu.value._costPercentage = cp > 0 ? ((total / y) / cp) * 100 : 0
    }
  } catch (err) {
    console.error('Error saving recipe details:', err)
    showToast(err.message || 'Failed to save recipe details', 'error')
  } finally {
    recipeSaving.value = false
  }
}

async function updateIngredientActive(row) {
  if (!row.id) return // New rows don't have id yet
  try {
    const res = await apiFetch(`/recipes/ingredient/${row.id}`, {
      method: 'PUT',
      body: JSON.stringify({ isActive: row.isActive ? 1 : 0 }),
    })
    if (!res.ok) {
      const err = await res.json().catch(() => ({}))
      showToast(err.message || 'Failed to update ingredient status', 'error')
      // Revert the change
      row.isActive = !row.isActive
      return
    }
    // Success, no need to show toast for every toggle
  } catch (err) {
    console.error('Error updating ingredient active:', err)
    showToast('Failed to update ingredient status', 'error')
    // Revert
    row.isActive = !row.isActive
  }
}

function toggleActive(row) {
  if (!canEditRecipe.value) return
  row.isActive = !row.isActive
  updateIngredientActive(row)
}

async function closeModal() {
  showModal.value = false
  editingIndex.value = -1
  resetForm()
  // Refresh table data on close to show updated costs/status
  if (selectedDepartmentId.value) {
    await handleDepartmentSelected()
  }
}

async function closeModalWithSave() {
  // await saveRecipeToBackend()
  await closeModal()
}

function resetForm() {
  addIngredient.value = ''
  addIngredientItemId.value = ''
  addQuantity.value = ''
  addUom.value = 'Kg'
  addUP.value = 0
  addRemark.value = ''
  editingIndex.value = -1
  selectedOtherRecipeId.value = ''
  remark.value = ''
}

async function loadIngredientsFromOther() {
  if (!selectedOtherRecipeId.value) return
  if (!selectedMenu.value?.id) return

  const sourceMenuId = Number(selectedOtherRecipeId.value)

  itemsLoading.value = true
  try {
    const res = await apiFetch(`/recipes/menu/${sourceMenuId}`, { method: 'GET' })
    if (!res.ok) {
      showToast('Failed to load ingredients from selected recipe.', 'error')
      return
    }
    const data = await res.json().catch(() => null)
    if (!data || !Array.isArray(data.ingredients)) {
      showToast('No ingredients found in the selected recipe.', 'info')
      return
    }

    let addedCount = 0
    const builtRows = await buildRecipeCostRowsFromApiIngredients(data.ingredients)

    for (const row of builtRows) {
      const exists = recipeRows.value.find(r =>
        (row.type === 'item' && r.itemId === row.itemId) ||
        (row.type === 'product' && r.productId === row.productId)
      )
      if (exists) continue

      // Imported rows are new to this menu recipe until saved.
      recipeRows.value.push({ ...row, id: null })
      addedCount++
    }

    if (addedCount > 0) {
      showToast(`Added ${addedCount} ingredient(s) to the list.`, 'success')
    } else {
      showToast('No new ingredients were added.', 'info')
    }
  } catch (err) {
    console.error('Error importing recipe:', err)
    showToast('An error occurred while importing ingredients.', 'error')
  } finally {
    itemsLoading.value = false
    selectedOtherRecipeId.value = ''
  }
}

async function fetchProductCost(productId, pQty = null) {
  if (!productId) return 0
  try {
    // 1. Resolve yield quantity + contingency (match ProductPage)
    let yieldQty = pQty
    let contingencyPct = null

    if (!yieldQty) {
      const opt = ingredientOptions.value.find(
        (o) => o.type === 'product' && String(o.id) === String(productId)
      )
      if (opt?.quantity) {
        yieldQty = Number(opt.quantity)
      }
      if (opt?.contingency != null) {
        contingencyPct = Number(opt.contingency)
      }
    }

    if (!yieldQty || contingencyPct == null) {
      const pRes = await apiFetch(`/products/${productId}`, { method: 'GET' })
      const prodRaw = await pRes.json().catch(() => ({}))
      const prod = prodRaw.data || prodRaw
      if (!yieldQty) yieldQty = Number(prod?.quantity || 1)
      if (contingencyPct == null) contingencyPct = Number(prod?.contingency ?? DEFAULT_PRODUCT_CONTINGENCY)
    }
    if (!yieldQty) yieldQty = 1
    if (contingencyPct == null || Number.isNaN(contingencyPct)) {
      contingencyPct = DEFAULT_PRODUCT_CONTINGENCY
    }

    // 2. Load this product recipe
    const res = await apiFetch(`/product-recipes/product/${productId}`, { method: 'GET' })
    if (!res.ok) return 0
    const data = await res.json().catch(() => null)
    if (!data || !Array.isArray(data.ingredients) || data.ingredients.length === 0) return 0

    const getProductDisplayUom = (u) => {
      const unitNorm = normalizeUnit(u)
      if (unitNorm === 'kg') return 'Gram'
      if (unitNorm === 'liter') return 'M.L.'
      return u ?? ''
    }

    // 3. Sum ingredient costs using ProductPage table logic
    let subtotal = 0
    for (const ing of data.ingredients) {
      if (ing.isActive === 0 || ing.isActive === '0') continue

      let up = 0
      if (ing.type === 'product') {
        const nestedProductId = ing.productId || ing.product_id || ing.product?.id
        const nestedRecentUp = Number(
          ing.product?.recent_unit_price ??
          ing.product?.recentUnitPrice ??
          ing.product?.recentPrice ??
          0
        )

        up = nestedRecentUp
        let fromFallback = false
        if (!up && nestedProductId && String(nestedProductId) !== String(productId)) {
          up = await fetchProductCost(nestedProductId)
          fromFallback = true
        }

        const productUom = ing.product?.uom || ing.unit || ''
        const productDisplayUom = getProductDisplayUom(productUom)

        if (!fromFallback) {
          const derived = computeUpFromRecentPriceAndVolume(
            productUom,
            productDisplayUom,
            ing.product?.recent_unit_price ?? ing.product?.recentUnitPrice ?? ing.product?.recentPrice ?? null,
            ing.product?.recent_volume ?? ing.product?.recentVolume ?? null
          )
          if (derived != null) up = derived
        }

        const total = Number(ing.quantity || 0) * up
        subtotal += isMlOrGram(productDisplayUom) ? (total / 1000) : total
      } else {
        const itemId = ing.itemId || ing.item_id
        const fullItem = items.value.find((it) => String(it.id) === String(itemId))
        const itemUnit = fullItem?.unit ?? ing.item?.unit ?? ''
        const itemUnitProduction = fullItem?.unitProduction ?? ing.item?.unitProduction ?? ing.unit ?? ''
        const itemRecentUnitPrice = (
          fullItem?.recent_unit_price ??
          fullItem?.recentPrice ??
          fullItem?.recentUnitPrice ??
          ing.item?.recent_unit_price ??
          ing.item?.recentPrice ??
          ing.item?.recentUnitPrice ??
          0
        )
        const itemRecentVolume = (
          fullItem?.recent_volume ??
          fullItem?.recentVolume ??
          ing.item?.recent_volume ??
          ing.item?.recentVolume ??
          null
        )
        const itemGlassAmount = (
          fullItem?.glass_amount ??
          fullItem?.glassAmount ??
          ing.item?.glass_amount ??
          ing.item?.glassAmount ??
          null
        )

        up = Number(itemRecentUnitPrice)
        const derivedItemUp = computeItemModalDisplayUp(
          itemUnit,
          itemUnitProduction,
          itemRecentUnitPrice,
          itemRecentVolume,
          itemGlassAmount
        )
        if (derivedItemUp != null) up = derivedItemUp

        const total = Number(ing.quantity || 0) * up
        subtotal += isMlOrGram(itemUnitProduction) ? (total / 1000) : total
      }
    }

    // 4. Match ProductPage: (Subtotal + product contingency%) / Yield
    const totalWithContingency = subtotal * (1 + contingencyPct / 100)
    return yieldQty > 0 ? (totalWithContingency / yieldQty) : 0
  } catch (err) {
    console.error('Error fetching product cost:', err)
    return 0
  }
}

async function buildRecipeCostRowsFromApiIngredients(ings) {
  return Promise.all((Array.isArray(ings) ? ings : []).map(async (i) => {
    const itemId = i.itemId ?? i.item_id ?? i.item?.id ?? null
    const productId = i.productId ?? i.product_id ?? i.product?.id ?? null
    const type = i.type || (productId ? 'product' : 'item')

    let up = 0
    let upFromFetchProductCost = false
    let ingredientName = ''
    let uom = ''

    if (type === 'item') {
      const fullItem = items.value.find(it => String(it.id) === String(itemId))
      up = Number(fullItem?.recent_unit_price ?? fullItem?.recentPrice ?? fullItem?.recentUnitPrice ?? i.item?.recent_unit_price ?? i.item?.recentPrice ?? i.item?.recentUnitPrice ?? 0)
      ingredientName = i.item?.itemName || i.itemName || ''
      uom = fullItem?.unitProduction || i.item?.unitProduction || i.unit || ''
    } else {
      ingredientName = i.product?.name || i.productName || 'Product'
      uom = i.product?.uom || i.unit || i.uom || ''
      const opt = ingredientOptions.value.find(o => o.type === 'product' && String(o.id) === String(productId))
      // Match ProductPage: prefer product recent_unit_price, else fetchProductCost.
      // Fall back to loaded product options only for recent_unit_price (not opt.up).
      const productRecentUp = Number(
        i.product?.recent_unit_price ??
        i.product?.recentUnitPrice ??
        i.product?.recentPrice ??
        opt?.recent_unit_price ??
        0
      )
      up = productRecentUp
      if (!up && productId) {
        up = await fetchProductCost(productId, opt?.quantity)
        upFromFetchProductCost = true
      }
    }

    const qty = Number(i.quantity || 0)
    const optForRecent = type === 'product'
      ? ingredientOptions.value.find(o => o.type === 'product' && String(o.id) === String(productId))
      : null
    return {
      id: i.id,
      itemId,
      productId,
      type,
      ingredient: ingredientName,
      uom,
      qty,
      up,
      total: qty * up,
      remark: i.remark || '',
      isActive: i.isActive ?? 1,
      upFromFetchProductCost,
      recent_unit_price: type === 'product'
        ? (i.product?.recent_unit_price ?? i.product?.recentUnitPrice ?? i.product?.recentPrice ?? optForRecent?.recent_unit_price ?? null)
        : null,
      recent_volume: type === 'product'
        ? (i.product?.recent_volume ?? i.product?.recentVolume ?? optForRecent?.recent_volume ?? null)
        : null,
    }
  }))
}

async function onIngredientSelect() {
  if (!addIngredientItemId.value) {
    addIngredient.value = ''
    addUom.value = 'Kg'
    addUP.value = 0
    return
  }

  const [type, id] = addIngredientItemId.value.split(':')
  const selected = ingredientOptions.value.find(opt => opt.type === type && String(opt.id) === String(id))
  
  if (selected) {
    addIngredient.value = selected.name
    addUom.value = selected.uom
    if (selected.type === 'product') {
      // Match ProductPage: prefer recent_unit_price (opt.up), fallback to recipe cost.
      const optUp = Number(selected.up || 0)
      addUP.value = optUp ? optUp : await fetchProductCost(selected.id, selected.quantity)
    } else {
      addUP.value = selected.up
    }
  } else {
    addIngredient.value = ''
    addUom.value = 'Kg'
    addUP.value = 0
  }
}

async function saveIngredient() {
  if (!canSubmitRecipeIngredient.value) return
  if (!addIngredientItemId.value || !addQuantity.value) return
  if (!selectedMenu.value?.id) return

  const [type, id] = addIngredientItemId.value.split(':')
  const selected = ingredientOptions.value.find(opt => opt.type === type && String(opt.id) === String(id))
  if (!selected) return

  const rowData = {
    itemId: type === 'item' ? Number(id) : null,
    productId: type === 'product' ? Number(id) : null,
    type,
    ingredient: selected.name,
    uom: addUom.value,
    qty: Number(addQuantity.value),
    up: Number(addUP.value || 0),
    total: Number(addQuantity.value) * Number(addUP.value || 0),
    upFromFetchProductCost: type === 'product',
    recent_unit_price: type === 'product' ? Number(selected.recent_unit_price ?? selected.recentUnitPrice ?? 0) : null,
    recent_volume: type === 'product' ? Number(selected.recent_volume ?? selected.recentVolume ?? 0) : null,
    remark: addRemark.value || '',
    isActive: 1,
  }

  // Prevent ingredient duplication before adding/updating.
  const duplicateIndex = recipeRows.value.findIndex((r, idx) => {
    if (editingIndex.value !== -1 && idx === editingIndex.value) return false
    return (type === 'item' && r.itemId === rowData.itemId) ||
      (type === 'product' && r.productId === rowData.productId)
  })
  if (duplicateIndex !== -1) {
    showToast('This ingredient has already been added to the recipe.', 'error')
    return
  }

  if (editingIndex.value === -1) {
    recipeRows.value.push({
      ...rowData,
      id: null,
    })
  } else {
    const existing = recipeRows.value[editingIndex.value]
    if (!existing) return
    recipeRows.value[editingIndex.value] = {
      ...existing,
      ...rowData,
      // Keep id for existing rows so Save can perform update.
      id: existing.id ?? null,
      // Preserve DB-derived product hints unless explicitly provided.
      recent_unit_price: rowData.recent_unit_price ?? existing.recent_unit_price ?? null,
      recent_volume: rowData.recent_volume ?? existing.recent_volume ?? null,
    }
  }

  resetForm()
}

function editRow(index) {
  if (!canEditRecipe.value) return
  const row = recipeRows.value[index]
  editingIndex.value = index
  addIngredient.value = row.ingredient
  addIngredientItemId.value = row.type + ':' + (row.itemId || row.productId)
  addQuantity.value = row.qty
  addUom.value = row.uom
  addUP.value = row.up
  addRemark.value = row.remark || ''
}

async function deleteRow(index) {
  if (!canEditRecipe.value) return
  const row = recipeRows.value[index]
  if (!row) return

  if (row.id) {
    if (!deletedIngredientIds.value.includes(row.id)) {
      deletedIngredientIds.value.push(row.id)
    }
  }
  // Remove immediately from the list; DB delete will happen on Save.
  recipeRows.value.splice(index, 1)
}

function openContingencyModal(menu) {
  const menuId = Number(menu?.id)
  if (!Number.isFinite(menuId) || menuId <= 0) return
  editingContingencyMenuId.value = menuId
  contingencyValue.value = String(menu?.contingency ?? 10)
  showContingencyModal.value = true
}

function closeContingencyModal() {
  showContingencyModal.value = false
  editingContingencyMenuId.value = null
  contingencyValue.value = ''
}

async function saveContingency() {
  const menuId = Number(editingContingencyMenuId.value)
  if (Number.isFinite(menuId) && menuId > 0) {
    const menu = menuData.value.find((row) => Number(row?.id) === menuId)
    if (!menu) {
      showToast('Menu not found', 'error')
      return
    }
    const newContingency = Number(contingencyValue.value) ?? 10;
    
    try {
      const res = await apiFetch(`/menu-lists/${menu.id}`, {
        method: 'PUT',
        body: JSON.stringify({ contingency: newContingency }),
      });
      if (!res.ok) {
        showToast('Failed to update contingency', 'error');
        return;
      }
      menu.contingency = newContingency;
      if (menu._cost) {
        await loadRecipesAndCostsForMenus([menu]);
      }
      showToast('Contingency updated successfully', 'success');
      closeContingencyModal();
    } catch (err) {
      console.error('Error updating contingency:', err);
      showToast('Error updating contingency', 'error');
    }
  }
}

// function goToMenuList() {
//   closeModal()
//   router.push({ name: 'menu_list' })
// }

onMounted(() => {
  loadMenus()
  loadDepartmentsForRecipe()
  loadItemsForRecipe()
})
</script>

<style scoped>
.recipe-modal {
  display: block;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 16px;
}

.recipe-modal-content {
  background-color: white;
  margin: 5% auto;
  padding: 20px;
  width: 80%;
  max-height: 85vh;
  overflow-y: auto;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.close-modal {
  float: right;
  font-size: 24px;
  cursor: pointer;
  font-weight: bold;
  color: #334155;
  line-height: 1;
}

.close-modal:hover {
  color: #0f172a;
}

#modalTitle {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: #1e293b;
}

table {
  font-family: 'Segoe UI', sans-serif;
  font-size: 0.75rem;
  color: #1e293b;
}

th,
td {
  padding: 8px 10px;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
}

th {
  background: #f1f5f9;
  cursor: default;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 20;
}

.sticky-col {
  position: sticky;
  left: 0;
  z-index: 10;
  background-clip: padding-box;
  border-right: 2px solid #e2e8f0 !important;
}

th.sticky-col {
  z-index: 30;
}

.recipe-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
}

/* Custom scrollbar */
.custom-scrollbar::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: #f1f5f9;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Toast Transitions */
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

/* Toggle Switch Styles */
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 28px;
  height: 14px;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #dc2626;
  transition: .4s;
  border-radius: 14px;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 10px;
  width: 10px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

.toggle-switch input:checked + .toggle-slider {
  background-color: #16a34a;
}

.toggle-switch input:checked + .toggle-slider:before {
  transform: translateX(14px);
}

.toggle-slider.active {
  background-color: #16a34a;
}

.toggle-slider.active:before {
  transform: translateX(14px);
}

.action-disabled-marker {
  position: relative;
}

.action-disabled-marker:hover::after {
  content: '⊘';
  position: absolute;
  top: -8px;
  right: -10px;
  font-size: 12px;
  font-weight: 700;
  color: #dc2626;
  line-height: 1;
  pointer-events: none;
}
</style>

